import {Box, BoxProps} from "@mui/material";
import {PropsWithChildren} from "react";
import {spacing} from "../theme";

type SpacingKey = keyof typeof spacing;

type ContainerProps = PropsWithChildren<Omit<BoxProps, "gap">> & {
  row?: boolean;
  center?: boolean;
  fullWidth?: boolean;
  gap?: SpacingKey;
};

export const Container = ({row, center, fullWidth, gap = 4, children, onClick, sx, ...props}: ContainerProps) => (
  <Box
    onClick={onClick}
    sx={{
      display: "flex",
      flexDirection: row ? "row" : "column",
      gap: spacing[gap],
      ...(fullWidth && {width: "100%"}),
      ...(center && {alignItems: "center", justifyContent: "center"}),
      ...(onClick && {cursor: "pointer"}),
      ...sx,
    }}
    {...props}
  >
    {children}
  </Box>
);
